import React, { useState, useRef, useEffect } from 'react';
import { FaBell, FaSearch, FaBars, FaPen } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

function DashboardHeader({ toggleSidebar }) {
  const location = useLocation();
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [mobileProfileMenuOpen, setMobileProfileMenuOpen] = useState(false);
  const profileMenuRef = useRef(null);
  const profileImageRef = useRef(null);
  const mobileProfileImageRef = useRef(null);

  const profileData = {
    name: 'Parth',
    profileImage: 'path-to-your-image',
  };

  const getHeaderTitle = () => {
    switch (location.pathname) {
      case '/dashboard':
        return 'Dashboard';
      case '/my-folder':
        return 'My Folder';
      case '/my-documents':
        return 'My Documents';
      case '/bin':
        return 'Bin';
      case '/nft':
        return 'NFT';
      case '/support':
        return 'Support';
      default:
        return 'Dashboard';
    }
  };

  const handleProfileMenuToggle = () => {
    setProfileMenuOpen(!profileMenuOpen);
  };

  const handleMobileProfileMenuToggle = () => {
    setMobileProfileMenuOpen(!mobileProfileMenuOpen);
  };

  const handleClickOutsideMenu = (event) => {
    if (
      profileMenuRef.current &&
      !profileMenuRef.current.contains(event.target) &&
      profileImageRef.current &&
      !profileImageRef.current.contains(event.target)
    ) {
      setProfileMenuOpen(false);
    }

    if (
      profileMenuRef.current &&
      !profileMenuRef.current.contains(event.target) &&
      mobileProfileImageRef.current &&
      !mobileProfileImageRef.current.contains(event.target)
    ) {
      setMobileProfileMenuOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideMenu);
    return () => {
      document.removeEventListener('click', handleClickOutsideMenu);
    };
  }, []);

  useEffect(() => {
    // Close profile menu when navigating away from the current page
    setProfileMenuOpen(false);
    setMobileProfileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="flex flex-wrap justify-between items-center p-4 bg-blue-100 shadow-md relative">
      <div className="w-full lg:w-auto flex justify-between lg:justify-start items-center">
        <div className="flex items-center">
          <h1 className="text-xl font-bold text-[#737791]">{getHeaderTitle()}</h1>
        </div>
        <div className="flex items-center lg:hidden space-x-4 relative">
          <FaBell className="text-xl" />
          <div className="relative">
            <div className="flex items-center">
              <img
                ref={mobileProfileImageRef}
                src={profileData.profileImage}
                alt="Profile"
                className="w-10 h-10 rounded-full cursor-pointer"
                onClick={handleMobileProfileMenuToggle}
              />
              {mobileProfileMenuOpen && (
                <div
                  className="absolute top-12 right-0 bg-white mt-2 rounded-lg shadow-lg border border-gray-200 py-1 z-10"
                  style={{ minWidth: '10rem' }}
                  ref={profileMenuRef}
                >
                  <div className="flex items-center justify-center p-2">
                    <img
                      src={profileData.profileImage}
                      alt="Profile"
                      className="w-16 h-16 rounded-full cursor-pointer"
                    />
                    <div className="absolute top-0 right-0 bg-white mt-6 ml-12 rounded-lg shadow-lg border border-gray-200 py-1 z-10">
                      <FaPen className="text-xl text-gray-600 cursor-pointer" />
                    </div>
                  </div>
                  <div className="p-2">
                    <Link to="/profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-100">Edit Profile</Link>
                    <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-100">Sign Out</a>
                  </div>
                </div>
              )}
            </div>
          </div>
          <FaBars className="text-xl cursor-pointer" onClick={toggleSidebar} />
        </div>
      </div>
      <div className="w-full lg:w-auto flex justify-center lg:justify-start mt-4 lg:mt-0 relative">
        <span className="absolute inset-y-0 left-0 flex items-center pl-3">
          <FaSearch className="text-blue-600" />
        </span>
        <input
          type="text"
          placeholder="Search here..."
          className="border rounded-lg pl-10 pr-4 py-2 w-full lg:w-64"
        />
      </div>
      <div className="hidden lg:flex w-full lg:w-auto justify-end lg:justify-start items-center mt-4 lg:mt-0 space-x-8">
        <FaBell className="text-xl" />
        <div className="relative">
          <div className="flex items-center">
            <img
              ref={profileImageRef}
              src={profileData.profileImage}
              alt="Profile"
              className="w-10 h-10 rounded-full cursor-pointer"
              onClick={handleProfileMenuToggle}
            />
            {profileMenuOpen && (
              <div
                className="absolute top-12 right-0 bg-white mt-2 rounded-lg shadow-lg border border-gray-200 py-1 z-10"
                style={{ minWidth: '10rem' }}
                ref={profileMenuRef}
              >
                <div className="flex items-center justify-center p-2">
                  <img
                    src={profileData.profileImage}
                    alt="Profile"
                    className="w-16 h-16 rounded-full cursor-pointer"
                  />
                  <div className="absolute top-0 right-0 bg-white mt-6 ml-12 rounded-lg shadow-lg border border-gray-200 py-1 z-10">
                    <FaPen className="text-xl text-gray-600 cursor-pointer" />
                  </div>
                </div>
                <div className="p-2">
                  <Link to="/profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-100">Edit Profile</Link>
                  <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-100">Sign Out</a>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}

export default DashboardHeader;
